<!--Custom saved request-->
<div class="grid">
  <div class="col-12 savedSearch">
    <app-get-or-remove-or-schedule-saved-request
      (selectedRequest)="setActiveRequest($event)"></app-get-or-remove-or-schedule-saved-request>
  </div>
</div>
<hr>


<div class="grid">
  <div class="col-5" *ngIf="enableRefresh">
    <h3>{{ 'SEARCH_COMPONENT.FORM.AUTO-REFRESH' | translate }}</h3>
  </div>
  <div class="col-5" *ngIf="enableRefresh">
    <p-selectButton [options]="refreshLabels" [(ngModel)]="autoRefresh"
                    (onChange)="updateAutoRefresh( )"></p-selectButton>
  </div>
  <div class="col-2">
    <div *ngIf="autoRefresh" class="col-9 refresh-spinner">
      <div class="fa-stack">
        <i class="fa fa-circle-o-notch fa-spin fa-stack-2x"></i>
        <span class="fa fa-stack-1x">{{timeLeft}}</span>
      </div>

    </div>
  </div>
</div>

<!--Date Filterting-->

<p-fieldset [toggleable]="false" [legend]="'SEARCH_COMPONENT.FORM.TITLE_FILTER_DATE' | translate">
  <div class="grid">
    <div class="col-12">
      <div class="col-5">
        <h3>{{ 'SEARCH_COMPONENT.FORM.TITLE_FILTER_DATE_LABEL'| translate}}</h3>
      </div>
      <div class="col-7">
        <p-selectButton [options]="searchDateTypes" [(ngModel)]="searchDateType"
                        (onChange)="ensureSearchType()"></p-selectButton>
      </div>
    </div>

    <div class="col-5">
      <p-dropdown id="dateFilter" [options]="dateOptions" [(ngModel)]="selectedDateOption"
                  (onChange)="resetDateOptionsValues()" [style]="{'width':'100%'}"></p-dropdown>
    </div>

    <div id="searchCustomPeriod" class="col-7">

      <div *ngIf="selectedDateOption === dateOptionsEnum.CUSTOM_PERIOD"
           [ngClass]="{'requestedField': customPeriodEntryIsNotValid() }">
        <p-calendar #customPeriodCal [(ngModel)]="selectedDates" [dateFormat]="'dd/mm/yy'" [selectionMode]="'range'"
                    [readonlyInput]="true" [showButtonBar]="true"
                    (onSelect)="dateSelected()"
                    [showIcon]="true" [minDate]="yearRange[0]" [maxDate]="yearRange[1]"></p-calendar>
      </div>

      <div *ngIf="selectedDateOption === dateOptionsEnum.OTHER_WEEK">
        <!--<p-spinner [(ngModel)]="weekNumber" [min]="1" [max]="52" (onChange)="updateWeekLabel()"
                   [placeholder]="'entre 1 et 52'" [size]="7"></p-spinner>-->
        <p-inputNumber inputmode="numeric" [(ngModel)]="weekNumber" [min]="1" [max]="52" [maxlength]="2" [showButtons]="true" (onInput)="updateWeekLabel()" > </p-inputNumber>
        <span>{{weekLabel}}</span>
      </div>

      <div *ngIf="selectedDateOption === dateOptionsEnum.OTHER_MONTH">
        <p-spinner [(ngModel)]="monthNumber" [maxlength]="2" [min]="1" [max]="12"
                   [placeholder]="'entre 1 et 12'" [size]="7"></p-spinner>
      </div>

    </div>
  </div>
</p-fieldset>
<p-fieldset [toggleable]="false" [legend]="'SEARCH_COMPONENT.PROOF.TITLE' | translate">

  <div class="grid">
    <div class="col-12">
      <p-selectButton [options]="searchStatusTypes" [(ngModel)]="searchStatusType" (onChange)="changeFilterStatus()"></p-selectButton>
    </div>

    <div class="col-5" *ngIf="searchStatusType === FilterStatusTypeEnum.DISTRIBUTION">
      <p-dropdown id="proofFilter" [options]="proofTypeOptions" [(ngModel)]="proofType"
                  [style]="{'width':'100%'}"></p-dropdown>
    </div>

    <div class="col-5" *ngIf="searchStatusType === FilterStatusTypeEnum.FOLD">
      <p-dropdown id="statusFilter" [options]="statusTypeOptions" [(ngModel)]="statusType"
                  [style]="{'width':'100%'}"></p-dropdown>
    </div>

    <div class="col-5" *ngIf="searchStatusType === FilterStatusTypeEnum.MAIL">
      <p-dropdown id="statusFilterMail" [options]="mailStatusTypeOptions" [(ngModel)]="mailType"
                  [style]="{'width':'100%'}"></p-dropdown>
    </div>

    <div class="col-5" *ngIf="searchStatusType === FilterStatusTypeEnum.ERL">
      <p-dropdown id="statusFilterErl" [options]="erlStatusTypeOptions" [(ngModel)]="erlType"
                  [style]="{'width':'100%'}"></p-dropdown>
    </div>
  </div>
</p-fieldset>
<hr>
<!-- Kind of search and deposit selection-->
<div id="kindOfSearch" class="grid">
  <div class="col-5">
    <h3>{{ 'SEARCH_COMPONENT.FORM.SEARCH_TYPE_LABEL' | translate }}</h3>
  </div>
  <div class="col-7">
    <p-selectButton [disabled]="this.searchDateType === 'PRODUCTION'" [options]="searchTypes"
                    [(ngModel)]="searchType"></p-selectButton>
  </div>
</div>
<!--Advanced filters title-->
<div *ngIf="searchType === 'FOLDS'">
  <div class="grid" id="searchLines">
    <div class="col-12">
      <h3>{{ 'SEARCH_COMPONENT.FORM.TITLE_FILTER_ADVANCED' | translate }}</h3>
    </div>
  </div>

  <!--Advanced filters-->
  <div id="advancedFilters" class="col-12 " *ngFor="let criteria of criterias;let i = index">
    <!-- [fieldValue]="depositNumber"-->
    <!--<app-search-filter *ngIf="criteriaIsDepositNumber(criteria)" [criteria]="criteria"></app-search-filter>-->
    <!--[fieldValue]="sendNumber"-->
    <!--<app-search-filter *ngIf="criteriaIsSendNumber(criteria)" [(criteria)]="criteria"></app-search-filter>-->
    <!--[fieldValue]="criteria.sCriteriaTrackingValue" -->
    <app-search-filter [(criteria)]="criterias[i]" fieldValue=""></app-search-filter>

  </div>
</div>
<!--Save, search or update request buttons-->
<div id="searchActionButtons" class="col-12 center">

  <!--update request button-->
  <div class="col-3">
    <button pButton type="button" [icon]="'fa fa-floppy-o'" class="p-button-success fullwidth"
            [label]="'SEARCH_COMPONENT.FORM.BUTTON_UPDATE' | translate"
            (click)="openAddOrUpdateSavedRequest= !openAddOrUpdateSavedRequest">
    </button>
  </div>

  <!--Report button
  *ngIf="currentUser.admin == true" -->
  <div class="col-3">
    <button pButton type="button" [icon]="'fa fa-file-excel-o'" class="fullwidth"
            [label]="'SEARCH_COMPONENT.FORM.BUTTON_REPORT' | translate"
            (click)="generateReport()">
    </button>
  </div>
  <!--Export button-->
  <div class="col-3">
    <button pButton type="button" [icon]="'fa fa-file-excel-o'" class="fullwidth"
            [label]="'SEARCH_COMPONENT.FORM.BUTTON_EXPORT' | translate"
            (click)="exportAsCSV()"
            [disabled]="!searchEnabled()">
    </button>
  </div>

  <!--Search button-->
  <div class="col-3">
    <button pButton type="button" [icon]="'fa fa-search'" id="searchButton" class="fullwidth"
            [label]="'SEARCH_COMPONENT.FORM.BUTTON_SEARCH' | translate"
            (click)="search()"
            [disabled]="!searchEnabled()">
    </button>
  </div>

</div>

<app-add-or-update-saved-request
  [(displayComponent)]="openAddOrUpdateSavedRequest"
  [selectedRequestName]="currentRequestName"
  [bDepotDay]="selectedDateOption === DateFiltered.TODAY"
  [bDepotMonth]="selectedDateOption === DateFiltered.CURRENT_MONTH"
  [bDepotWeek]="selectedDateOption === DateFiltered.CURRENT_WEEK"
  [bDepotYesterday]="selectedDateOption === DateFiltered.YESTERDAY"
  [bLimitedDeposit]="searchType === 'DEPOSITS'"
  [bLimitedSent]="searchType === 'FOLDS'"
  [iDepotWeekNum]="weekNumber"
  [iDepotMonthNum]="monthNumber"
  [searchCriterias]="criterias"
  [dateDepotBegin]="selectedDates && selectedDates[0] ? selectedDates[0] : null"
  [dateDepotEnd]="selectedDates && selectedDates[1] ? selectedDates[1] : null"
  [selectedDateOption]="selectedDateOption">
</app-add-or-update-saved-request>

<div *ngIf="openReportGenerator">
  <app-generate-report [(displayComponent)]="openReportGenerator">

  </app-generate-report>
</div>
